AuthRoute = require 'mixins/authenticated-route'

###
# List all couriers
###
App.RestaurantsRoute = Em.Route.extend AuthRoute,
  model: ->
    @store.find 'restaurant'
    # params = {}

    # params.organization_id = @get('session').get('currentOrganization.id')

    # @store.filter('restaurant', params, (restaurant) ->
    #   restaurant.get('organization.id') is params.organization_id
    # )
